<template>
    <div style="width:100%;height:100%;overflow:hidden">

        <faq-component :info="info" v-model="infoData.Faq" @projectChange="onProjectChange"></faq-component>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import projectMixin from '../helpers/project-mixin'
    import UI from '../helpers/ui-helpers';
    import BackendApi from '../backendApi';

    let backendApi = new BackendApi();

    export default {
        name: "faq",

        props: ['info'],

        mixins: [projectMixin],

        data(){
            return {
                infoData: {},
                faqData: null
            }
        },

        methods:{

            onProjectChange(){
                this.$emit('user-updated');
                this.loadFaq();
            },

            loadFaq() {
                let vm = this;
                return this.callApiWrapper(backendApi.projectInfoFilter())
                    .then(function (resp) {
                        if (resp.hasError) {
                            UI.toastr.error('Ошибка во время загрузки вопросов');
                        }
                        else {
                            if (resp.data) {
                                //console.info('resp.data', resp.data);
                                vm.infoData = Object.assign({}, resp.data);
                            }
                        }
                        UI.unblockUI('.dataContent');
                        vm.loading = false;
                    })
                    .catch(function (err) {
                        console.info('err', err)
                        UI.toastr.error('Ошибка во время загрузки');
                    })
            },
        },

        mounted() {
            let vm = this;

            UI.blockUI('.dataContent', 'Загрузка...');
            vm.loadFaq().then(() => {
                UI.unblockUI('.dataContent');
            });
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/views/FaqPage.vue